// Constants
import { CompanyName } from '../Constants';

// Import Images
import Image1 from '../../assets/images/main/the-tavistock-hotel-and-inn-food-004397.webp';
import Image2 from '../../assets/images/building/the-tavistock-inn-hotel-and-food-10.webp';
import Image3 from '../../assets/images/main/the-tavistock-hotel-and-inn-4.webp';
import Image4 from '../../assets/images/main/the-tavistock-hotel-and-inn-food-03054.webp';
import Image5 from '../../assets/images/building/the-tavistock-inn-hotel-and-food-5.webp';
import Image6 from '../../assets/images/building/the-tavistock-inn-hotel-and-food-12.webp';
import Image7 from '../../assets/images/food/tavy-inn-food-7-1200.webp';
import Image8 from '../../assets/images/building/the-tavistock-inn-hotel-and-food-7.webp';

// Image Data Array
export const smallGalleryImagesArray = [
  {
    id: 1,
    src: Image1,
    name: 'Tavistock Inn - Cozy Lounge',
    alt: `${CompanyName} cozy lounge with a welcoming atmosphere`,
    ariaLabel: 'Gallery image 1',
  },
  {
    id: 2,
    src: Image2,
    name: 'Tavistock Inn - Classic Bar',
    alt: `${CompanyName} featuring its classic bar setup`,
    ariaLabel: 'Gallery image 2',
  },
  {
    id: 3,
    src: Image3,
    name: 'Tavistock Inn - Beautiful Exterior',
    alt: `${CompanyName} with its historic and charming exterior`,
    ariaLabel: 'Gallery image 3',
  },
  {
    id: 4,
    src: Image7,
    name: 'Tavistock Inn - Relaxing Beer Garden',
    alt: `${CompanyName} with a beautiful outdoor beer garden`,
    ariaLabel: 'Gallery image 5',
  },
  {
    id: 5,
    src: Image6,
    name: 'Tavistock Inn - Cozy Fireplace',
    alt: `${CompanyName} with a warm fireplace for winter nights`,
    ariaLabel: 'Gallery image 6',
  },
    {
    id: 6,
    src: Image4,
    name: 'Tavistock Inn - Elegant Dining Area',
    alt: `${CompanyName} providing an elegant dining experience`,
    ariaLabel: 'Gallery image 4',
  },
  {
    id: 7,
    src: Image5,
    name: 'Tavistock Inn - Traditional English Pub',
    alt: `${CompanyName} showcasing its traditional pub design`,
    ariaLabel: 'Gallery image 7',
  },
  {
    id: 8,
    src: Image8,
    name: 'Tavistock Inn - Welcoming Entrance',
    alt: `${CompanyName} inviting entrance to the hotel and pub`,
    ariaLabel: 'Gallery image 8',
  },
];
